import "./RoundedBox.css";

const RoundedBox = ({ children, style = {} }) => {
    return <div className="rounded-box" style={style}>{children}</div>
}

export default RoundedBox;